export const posts = [
  {
    url: "test",
    title: "Test Test",
    markdownFileName: "test.md",
    imageFileName: "test.png",
    date: "2023-02-27T10:50:00+03:00",

    seo: {
      description: "How to Work",
      keywords: "how, to, work",
    },
  },
];
